/*گلخانه*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={92.25}
      height={88.657}
      viewBox="0 0 92.25 88.657"
      {...props}
    >
      <g data-name="Group 376">
        <g data-name="Group 373">
          <g data-name="Group 372">
            <g data-name="Group 371">
              <path
                data-name="Path 7740"
                d="M46.125 4.593L7.149 29.725v54.283H85.1V29.725z"
                fill="#f2f9ff"
              />
              <path
                data-name="Path 7741"
                d="M46.125 4.593l-8.68 5.6 35.884 23.138v50.68H85.1V29.725z"
                fill="#e2f4ff"
              />
              <path
                data-name="Path 7742"
                d="M1.348 31.792a3.622 3.622 0 005.585 3.044l38.043-24.53a2.114 2.114 0 012.291 0l38.043 24.53a3.622 3.622 0 003.925-6.088L47.27 1.687a2.114 2.114 0 00-2.291 0L3.011 28.748a3.622 3.622 0 00-1.663 3.044z"
                fill="#afe2f7"
              />
            </g>
          </g>
          <path
            data-name="Path 7743"
            d="M46.772 25.475a.8.8 0 00-1.257 0c-2.744 3.751-12.952 19.483.606 29.663h.044c13.559-10.176 3.352-25.908.607-29.663z"
            fill="#b5e245"
          />
          <path
            data-name="Path 7744"
            d="M76.093 83.102c-7.432-6.095-18.106-9.917-29.969-9.917s-22.537 3.822-29.969 9.917z"
            fill="#ce9875"
          />
          <path
            data-name="Path 7745"
            d="M87.63 87.306H4.62a3.268 3.268 0 010-6.536h83.01a3.268 3.268 0 010 6.536z"
            fill="#e4936b"
          />
          <path
            data-name="Path 7746"
            d="M87.63 80.77h-8.415v3.268a3.268 3.268 0 01-3.268 3.268H87.63a3.268 3.268 0 100-6.536z"
            fill="#dd6938"
          />
        </g>
        <g data-name="Group 374">
          <path
            data-name="Path 7747"
            d="M50.304 63.062c-.107.377.344.742.868.8 19.7 2.053 24.321-12.782 23.314-14.515-.83-1.433-19.352-3.315-24.182 13.715z"
            fill="#c6e873"
          />
        </g>
        <g data-name="Group 375">
          <path
            data-name="Path 7748"
            d="M41.946 63.062c.107.377-.344.742-.868.8-19.697 2.049-24.319-12.785-23.314-14.521.83-1.427 19.353-3.309 24.182 13.721z"
            fill="#c6e873"
          />
        </g>
      </g>
      <path
        data-name="Path 7749"
        d="M87.63 79.418h-1.178V36.706c5.3.91 8.036-6.18 3.519-9.094l-8.782-5.662a1.351 1.351 0 10-1.465 2.271l8.782 5.663c2.472 1.595.1 5.467-2.461 3.816L48 9.17a3.472 3.472 0 00-3.756 0L6.2 33.701a2.271 2.271 0 01-2.461-3.816L45.712 2.823a.764.764 0 01.826 0l27.876 17.975a1.351 1.351 0 101.465-2.268L48 .552a3.472 3.472 0 00-3.756 0L2.278 27.613A4.982 4.982 0 005.8 36.704v31.745a1.351 1.351 0 102.7 0V35.436l37.211-23.994a.765.765 0 01.827 0l37.211 23.994v43.982H73.316a50.242 50.242 0 00-25.743-7.564 11.472 11.472 0 013.156-6.7 2.693 2.693 0 00.3.05c19.82 2.064 26.432-13.039 24.661-16.466l-.024-.047-.013-.026c-.288-.5-.926-1.1-3.324-1.413a22 22 0 00-5.367.042C58.431 48.365 51.6 53.53 49 62.693a1.746 1.746 0 00-.064.43 12.94 12.94 0 00-1.446 1.654v-8.955c10.29-8.187 7.888-20.866.369-31.141a2.153 2.153 0 00-3.437 0c-7.513 10.268-9.935 22.941.366 31.139v8.818a11.824 11.824 0 00-1.483-1.571 1.747 1.747 0 00-.063-.374 20.679 20.679 0 00-7.772-11.519 22.971 22.971 0 00-15.55-3.923c-2.379.306-3.026.908-3.317 1.4v.007c-1.674 2.882 3.6 16.74 20.856 16.74a30.131 30.131 0 004.121-.266 10.161 10.161 0 013.2 6.713 50.26 50.26 0 00-25.834 7.566H8.5v-4.614a1.351 1.351 0 10-2.7 0v4.621H4.62a4.62 4.62 0 100 9.239h83.01a4.619 4.619 0 100-9.238zm-33.9-16.735a104.687 104.687 0 0119.28-11.225c-1.827 6.051-8.466 11.598-19.282 11.226zM70.13 49.8a105.178 105.178 0 00-17.2 10.1c3.346-6.945 10.262-10.17 17.198-10.1zM39.467 60.216a154.985 154.985 0 00-17.68-10.409c7.09-.196 14.318 3.1 17.68 10.409zm-20.192-8.645a153.038 153.038 0 0119.013 11.118c-10.575.286-17.125-5.128-19.013-11.118zm28.219.629V29.019c4.706 7.856 6.406 16.683 0 23.181zm-2.7-23.176v23.173c-6.404-6.498-4.706-15.324-.003-23.173zm23.051 50.394H24.4a50.762 50.762 0 0143.445 0zm19.785 6.537H4.62a1.917 1.917 0 010-3.834h83.01a1.917 1.917 0 010 3.834z"
      />
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
